export const INJECT_CONTEXT_BORDER = "\n----------以下是附加的背景信息------------\n";

export function isEnabled(val: any): boolean {
  return val === undefined || !!val;
}

// 首次初始化运行时配置快照时可能耗时 2 秒以上，后续读取内存快照通常很快。
export function getOpenClawConfig(runtime: any): any {
  // 新版优先使用 current()；2026.6.1 已提供，2026.7 起不再提供 loadConfig()。
  if (typeof runtime?.config?.current === 'function') {
    return runtime.config.current();
  }
  // 较老版本（如 2026.3.13）只有 loadConfig()；名称虽像文件读取，正常运行时返回的也是内存快照。
  if (typeof runtime?.config?.loadConfig === 'function') {
    return runtime.config.loadConfig();
  }
  throw new Error('OpenClaw runtime config API is unavailable');
}
